import React from "react";
import { Text } from "./Text";

export interface PriceProps {
  amount: number;
  currency?: string;
  originalAmount?: number;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  showCurrency?: boolean;
  className?: string;
}

export const Price: React.FC<PriceProps> = ({
  amount,
  currency = "USD",
  originalAmount,
  size = "md" as "xs" | "sm" | "md" | "lg" | "xl",
  showCurrency = true,
  className = "",
}) => {
  const formatCurrency = (value: number) => {
    return value !== undefined && value !== null
      ? new Intl.NumberFormat("en-US", {
          style: showCurrency ? "currency" : "decimal",
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value)
      : undefined;
  };

  const hasDiscount = originalAmount && originalAmount > amount;

  return (
    <div
      className={`${hasDiscount ? "flex items-center gap-2" : "text-right"} ${className}`}
    >
      <Text
        as="span"
        size={size as "xs" | "sm" | "md" | "lg" | "xl"}
        weight={hasDiscount ? "semibold" : "normal"}
        className={hasDiscount ? "text-red-600" : ""}
      >
        {formatCurrency(amount)}
      </Text>
      {hasDiscount ? (
        <Text as="span" size="sm" color="muted" className="line-through">
          {formatCurrency(originalAmount)}
        </Text>
      ) : null}
    </div>
  );
};

export default Price;
